// validationSchemas.js

import * as Yup from 'yup';

export const clientValidationSchema = Yup.object().shape({
    name: Yup.string()
    .matches(/^[A-Za-z\s]+$/, 'Name can only contain letters and spaces') // Only letters and spaces allowed
    .required('Name is required'),
    email: Yup.string().email('Invalid email').required('Email is required'),
    mobile: Yup.string()
    .matches(/^\d+$/, 'Mobile number can only contain digits')
    .required('Mobile is required'),
    password: Yup.string().required('Password is required'),
    contact_name: Yup.string().required('Contact Name is required'),
    address: Yup.string()
    .matches(/^[a-zA-Z0-9\s,'-./\\]+$/, 'Invalid characters in the address')
    .required('Address is required'),
    country: Yup.string().required('Country is required'),
    state: Yup.string().required('State is required'),
    cities: Yup.string().required('City is required'),
    pincode: Yup.string()
  .matches(/^\d+$/, 'Pincode must contain only numbers') 
  .length(6, 'Pincode must be exactly 6 digits') 
  .required('Pincode is required'),
});


export const clientValidationEditSchema = Yup.object().shape({
  name: Yup.string()
  .matches(/^[A-Za-z\s]+$/, 'Name can only contain letters and spaces') // Only letters and spaces allowed
  .required('Name is required'),
  email: Yup.string().email('Invalid email').required('Email is required'),
  mobile: Yup.string()
  .matches(/^\d+$/, 'Mobile number can only contain digits')
  .required('Mobile is required'),
  password: Yup.string().required('Password is required'),
  contact_name: Yup.string().required('Contact Name is required'),
  address: Yup.string()
  .matches(/^[a-zA-Z0-9\s,'-./\\]+$/, 'Invalid characters in the address')
  .required('Address is required'),
  country: Yup.string().required('Country is required'),
  state: Yup.string().required('State is required'),
  cities: Yup.string().required('City is required'),
  pincode: Yup.string()
.matches(/^\d+$/, 'Pincode must contain only numbers') 
.length(6, 'Pincode must be exactly 6 digits') 
.required('Pincode is required'),
});
